/**
 * Kilobyte, used for pricing storage.
 */
export const KB = 1000;
/**
 * Megabyte, used for pricing storage.
 */
export const MB = 1000 * KB;
/**
 * Gigabyte, used for pricing storage.
 */
export const GB = 1000 * MB;
/**
 * Terabyte, used for pricing storage.
 */
export const TB = 1000 * GB;
export const KiB = 1024;
export const MiB = 1024 * KiB;
export const GiB = 1024 * MiB;
export const TiB = 1024 * GiB;
//# sourceMappingURL=size-units.js.map